/*
 * Extract Formik field name from Funnelback URL search param key
 * e.g. if the param key is "f.Resource Type|resourceType"
 * then the field name is "resourceType"
 */
const composeFieldName = (paramKey) => {
  const delimiterIndex = paramKey.indexOf('|');
  if (!delimiterIndex) {
    return '';
  }
  const fieldKey = paramKey.slice(delimiterIndex + 1);
  /* Date "d" is a special case - set the field key
   * to "datePublished"
   */
  return fieldKey === 'd' ? 'datePublished' : fieldKey;
};

export default composeFieldName;
